/**
 * Login container (#961): shows the SWITCH edu-ID button next to the
 * ordinary Plone username/password login, instead of the stock
 * volto-authomatic behaviour of auto-redirecting to OIDC.
 * @module components/Login/Login
 */
import React, { useEffect, useState } from 'react';
import { oidcRedirect } from '@plone-collective/volto-authomatic/actions';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { Divider } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { Login as CoreLogin } from '@plone/volto/components';
import qs from 'query-string';
import EduIDLoginButton from './EduIDLoginButton';
import eduidMessages from '@fhnw/messages/eduid';

/**
 * Get return url function.
 * @function getReturnUrl
 * @param  {Object} location Location object.
 * @returns {string} Return url.
 */
function getReturnUrl(location) {
  return `${qs.parse(location.search).return_url || (location.pathname === '/login' ? '/' : location.pathname.replace('/login', ''))}`;
}

/**
 * Login function.
 * @function Login
 * @returns {JSX.Element} Markup of the Login page.
 */
function Login(props) {
  const dispatch = useDispatch();
  const [startedOIDC, setStartedOIDC] = useState(false);
  const loginOIDCValues = useSelector((state) => state.oidcRedirect);
  const location = useLocation();
  const [, setCookie] = useCookies();

  useEffect(() => {
    const next_url = loginOIDCValues.next_url;
    if (next_url && startedOIDC) {
      setStartedOIDC(false);
      // Give time to save state to localstorage
      setTimeout(function () {
        window.location.href = next_url;
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startedOIDC, loginOIDCValues]);

  const onSelectOIDC = () => {
    setStartedOIDC(true);
    setCookie('return_url', getReturnUrl(location), { path: '/' });
    dispatch(oidcRedirect('oidc'));
  };

  return (
    <div className="eduid-login">
      <div className="eduid-login__oidc">
        <EduIDLoginButton onClick={onSelectOIDC} />
        <Divider horizontal>
          <FormattedMessage {...eduidMessages.or} />
        </Divider>
      </div>
      <CoreLogin {...props} />
    </div>
  );
}

export default Login;
